import React from 'react';
import { Field, useFormikContext } from 'formik';
import { Typography } from '@material-tailwind/react';

import { FormErrorUI, FormLabelUI, AutoCompleteSelectUI } from '../../Interface';

const BiFilterFields = ({ autocompleteData, fieldErrorState }) => {
  const { fieldErrors } = fieldErrorState;
  const { values, validateField, setFieldValue, errors } = useFormikContext();

  const getBiFieldLabel = (fieldValue) => {
    return autocompleteData.biField?.find((item) => item.value === fieldValue)?.label ?? '';
  };

  return (
    <>
      <div className="mb-4">
        <Typography variant="h6" className="mr-2">
          Szűrhető mezők
        </Typography>
      </div>
      <div className="flex flex-col gap-y-4 mx-2 mb-2">
        {fieldErrors.length > 0 &&
          fieldErrors.map((error) => (
            <div key={error.id}>
              <FormErrorUI message={error.message} />
            </div>
          ))}
      </div>
      <div className="flex flex-col mx-4">
        <div className="w-1/4">
          <Field
            type="autocomplete"
            name="bpField"
            component={AutoCompleteSelectUI}
            fullWidth
            label={<FormLabelUI text="Üp szűrő" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.bpField} />}
            inputLabelProps={{ shrink: values.bpField !== null }}
            onChange={(_e, newVal) => {
              setFieldValue('bpField', newVal?.value ?? null).then(() => {
                validateField('bpField');
              });
            }}
            selectedValue={values.bpField ?? null}
            selectedLabelValue={getBiFieldLabel(values.bpField)}
            dataset={autocompleteData.biField}
          />
        </div>
        <div className="w-1/4">
          <Field
            type="autocomplete"
            name="custom1Field"
            component={AutoCompleteSelectUI}
            fullWidth
            label={<FormLabelUI text="Egyedi 1 szűrő" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.custom1Field} />}
            inputLabelProps={{ shrink: values.custom1Field !== null }}
            onChange={(_e, newVal) => {
              setFieldValue('custom1Field', newVal?.value ?? null).then(() => {
                validateField('custom1Field');
              });
            }}
            selectedValue={values.custom1Field ?? null}
            selectedLabelValue={getBiFieldLabel(values.custom1Field)}
            dataset={autocompleteData.biField}
          />
        </div>
        <div className="w-1/4">
          <Field
            type="autocomplete"
            name="yearField"
            component={AutoCompleteSelectUI}
            fullWidth
            label={<FormLabelUI text="Év szűrő" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.yearField} />}
            inputLabelProps={{ shrink: values.yearField !== null }}
            onChange={(_e, newVal) => {
              setFieldValue('yearField', newVal?.value ?? null).then(() => {
                validateField('yearField');
              });
            }}
            selectedValue={values.yearField ?? null}
            selectedLabelValue={getBiFieldLabel(values.yearField)}
            dataset={autocompleteData.biField}
          />
        </div>
        <div className="w-1/4">
          <Field
            type="autocomplete"
            name="halfYearField"
            component={AutoCompleteSelectUI}
            fullWidth
            label={<FormLabelUI text="Félév szűrő" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.halfYearField} />}
            inputLabelProps={{ shrink: values.halfYearField !== null }}
            onChange={(_e, newVal) => {
              setFieldValue('halfYearField', newVal?.value ?? null).then(() => {
                validateField('halfYearField');
              });
            }}
            selectedValue={values.halfYearField ?? null}
            selectedLabelValue={getBiFieldLabel(values.halfYearField)}
            dataset={autocompleteData.biField}
          />
        </div>
        <div className="w-1/4">
          <Field
            type="autocomplete"
            name="querterField"
            component={AutoCompleteSelectUI}
            fullWidth
            label={<FormLabelUI text="Negyedév szűrő" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.querterField} />}
            inputLabelProps={{ shrink: values.querterField !== null }}
            onChange={(_e, newVal) => {
              setFieldValue('querterField', newVal?.value ?? null).then(() => {
                validateField('querterField');
              });
            }}
            selectedValue={values.querterField ?? null}
            selectedLabelValue={getBiFieldLabel(values.querterField)}
            dataset={autocompleteData.biField}
          />
        </div>
        <div className="w-1/4">
          <Field
            type="autocomplete"
            name="weekField"
            component={AutoCompleteSelectUI}
            fullWidth
            label={<FormLabelUI text="Hét szűrő" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.weekField} />}
            inputLabelProps={{ shrink: values.weekField !== null }}
            onChange={(_e, newVal) => {
              setFieldValue('weekField', newVal?.value ?? null).then(() => {
                validateField('weekField');
              });
            }}
            selectedValue={values.weekField ?? null}
            selectedLabelValue={getBiFieldLabel(values.weekField)}
            dataset={autocompleteData.biField}
          />
        </div>
        <div className="w-1/4">
          <Field
            type="autocomplete"
            name="monthField"
            component={AutoCompleteSelectUI}
            fullWidth
            label={<FormLabelUI text="Hónap szűrő" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.monthField} />}
            inputLabelProps={{ shrink: values.monthField !== null }}
            onChange={(_e, newVal) => {
              setFieldValue('monthField', newVal?.value ?? null).then(() => {
                validateField('monthField');
              });
            }}
            selectedValue={values.monthField ?? null}
            selectedLabelValue={getBiFieldLabel(values.monthField)}
            dataset={autocompleteData.biField}
          />
        </div>
        <div className="w-1/4">
          <Field
            type="autocomplete"
            name="dateInterValField"
            component={AutoCompleteSelectUI}
            fullWidth
            label={<FormLabelUI text="Dátum intervallum szűrő" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.dateInterValField} />}
            inputLabelProps={{ shrink: values.dateInterValField !== null }}
            onChange={(_e, newVal) => {
              setFieldValue('dateInterValField', newVal?.value ?? null).then(() => {
                validateField('dateInterValField');
              });
            }}
            selectedValue={values.dateInterValField ?? null}
            selectedLabelValue={getBiFieldLabel(values.dateInterValField)}
            dataset={autocompleteData.biField}
          />
        </div>
        <div className="w-1/4">
          {/*@TODO responsible type if necessary*/}
          <Field
            type="autocomplete"
            name="responsibleField"
            component={AutoCompleteSelectUI}
            fullWidth
            label={<FormLabelUI text="Felelős szűrő" />}
            variant="standard"
            helperText={<FormErrorUI message={errors.responsibleField} />}
            inputLabelProps={{ shrink: values.responsibleField !== null }}
            onChange={(_e, newVal) => {
              setFieldValue('responsibleField', newVal?.value ?? null).then(() => {
                validateField('responsibleField');
              });
            }}
            selectedValue={values.responsibleField ?? null}
            selectedLabelValue={getBiFieldLabel(values.responsibleField)}
            dataset={autocompleteData.biField}
          />
        </div>
      </div>
    </>
  );
};

export default BiFilterFields;
